import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
class Footer extends React.Component
{
  render()
  {
    return (
        <div className="footerBox">
	<p className="text-center"> 
		@2016–2022 Thomas Quinn LLP</p> 
</div>
    )
  }
}
export default Footer;